/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SmallAttachment,
    SmallAttachmentFromJSON,
    SmallAttachmentFromJSONTyped,
    SmallAttachmentToJSON,
} from './';

/**
 * 
 * @export
 * @interface DocumentChange
 */
export interface DocumentChange {
    /**
     * 
     * @type {number}
     * @memberof DocumentChange
     */
    readonly id?: number;
    /**
     * 
     * @type {Array<SmallAttachment>}
     * @memberof DocumentChange
     */
    readonly attachments?: Array<SmallAttachment>;
    /**
     * 
     * @type {Date}
     * @memberof DocumentChange
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DocumentChange
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentChange
     */
    readonly type?: DocumentChangeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DocumentChange
     */
    series?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentChange
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentChange
     */
    divisionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentChange
     */
    issuedByWhom?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DocumentChange
     */
    dateOfIssue?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentChange
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentChange
     */
    citizenship?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentChange
     */
    placeOfBirth?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentChange
     */
    bankId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentChange
     */
    readonly owner?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentChange
     */
    readonly deal?: number;
}

export function DocumentChangeFromJSON(json: any): DocumentChange {
    return DocumentChangeFromJSONTyped(json, false);
}

export function DocumentChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentChange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(SmallAttachmentFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'series': !exists(json, 'series') ? undefined : json['series'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'divisionCode': !exists(json, 'divisionCode') ? undefined : json['divisionCode'],
        'issuedByWhom': !exists(json, 'issuedByWhom') ? undefined : json['issuedByWhom'],
        'dateOfIssue': !exists(json, 'dateOfIssue') ? undefined : (json['dateOfIssue'] === null ? null : new Date(json['dateOfIssue'])),
        'country': !exists(json, 'country') ? undefined : json['country'],
        'citizenship': !exists(json, 'citizenship') ? undefined : json['citizenship'],
        'placeOfBirth': !exists(json, 'placeOfBirth') ? undefined : json['placeOfBirth'],
        'bankId': !exists(json, 'bankId') ? undefined : json['bankId'],
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'deal': !exists(json, 'deal') ? undefined : json['deal'],
    };
}

export function DocumentChangeToJSON(value?: DocumentChange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'series': value.series,
        'number': value.number,
        'divisionCode': value.divisionCode,
        'issuedByWhom': value.issuedByWhom,
        'dateOfIssue': value.dateOfIssue === undefined ? undefined : (value.dateOfIssue === null ? null : value.dateOfIssue.toISOString().substr(0,10)),
        'country': value.country,
        'citizenship': value.citizenship,
        'placeOfBirth': value.placeOfBirth,
        'bankId': value.bankId,
    };
}

/**
* @export
* @enum {string}
*/
export enum DocumentChangeTypeEnum {
    Passport = 'passport',
    Inn = 'inn',
    Snils = 'snils',
    BirthCertificate = 'birth_certificate',
    ChildRepresentativeApproval = 'child_representative_approval',
    MarriageContract = 'marriage_contract',
    SpousesNotarialConsent = 'spouses_notarial_consent',
    PassportOriginal = 'passport_original',
    Apostille = 'apostille',
    MaternalCapitalCertificate = 'maternal_capital_certificate',
    MortgageCertificate = 'mortgage_certificate',
    SubsidyCertificate = 'subsidy_certificate'
}


